/**
 * @fileoverview This is a wrapper around the easing dot that adds
 * some SBI specific logic:
 *
 * 1. When a dot is hollow, show no fill and strengthen the stroke
 * 2. When a dot is a link, wrap the dot in SBI specific routing logic
 */

import React from 'react'
import SelectedLink from 'lib/components/selected-link'
import EasingDot from 'lib/components/charts/shapes/easing-dot'

class SmartBetaEasingDot extends React.PureComponent {
  static defaultProps = {
    label: '',
    isHollow: false,
    isLink: false,
    category: null,
    selected: null
  }

  render() {
    const { id, fill, category, label, isLink, isHollow, ...props } = this.props

    const dot = React.createElement(EasingDot, {
      ...props,
      fill: isHollow ? 'transparent' : fill,
      stroke: isHollow ? fill : 'transparent',
      strokeWidth: isHollow ? 2 : 1
    })

    if (isLink) {
      return (
        <SelectedLink
          category={category}
          selected={id}
          track={label}
          trackAs="chart-item"
          avoidHref={true}
        >
          {dot}
        </SelectedLink>
      )
    }

    return dot
  }
}

export default SmartBetaEasingDot



// WEBPACK FOOTER //
// ./src/components/charts/shapes/easing-dot.js